import { CustomSearchResults } from '@search/const';
import { StateUtils } from '@spartacus/core';
import { SEARCH_SUGGESTIONS } from '../search-state';

export const LOAD_SEARCH_SUGGESTIONS = '[Search] Search Suggestions Load';
export const LOAD_SEARCH_SUGGESTIONS_SUCCESS = '[Search] Search Suggestions Load Success';
export const LOAD_SEARCH_SUGGESTIONS_FAIL = '[Search] Search Suggestions Load Fail';
export const LOAD_SEARCH_SUGGESTIONS_CLEAR = '[Search] Search Suggestions Load Clear';
export const SEARCH_SUGGESTIONS_TOGGLE_OPEN = '[Search] Search Suggestions Toggle Open';

export class SearchSuggestionsLoad extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_SEARCH_SUGGESTIONS;

  constructor(public payload: string) {
    super(SEARCH_SUGGESTIONS);
  }
}
export class SearchSuggestionsLoadFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_SEARCH_SUGGESTIONS_FAIL;

  constructor(public payload: any) {
    super(SEARCH_SUGGESTIONS, payload);
  }
}

export class SearchSuggestionsLoadSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_SEARCH_SUGGESTIONS_SUCCESS;

  constructor(public payload: CustomSearchResults) {
    super(SEARCH_SUGGESTIONS);
  }
}

export class SearchSuggestionsLoadClear extends StateUtils.LoaderResetAction {
  readonly type = LOAD_SEARCH_SUGGESTIONS_CLEAR;

  constructor() {
    super(SEARCH_SUGGESTIONS);
  }
}

export type SearchSuggestionsLoadAction =
  | SearchSuggestionsLoad
  | SearchSuggestionsLoadFail
  | SearchSuggestionsLoadSuccess
  | SearchSuggestionsLoadClear;
